import { useMemo } from 'react';
import { useAppContext } from '../../context/AppContext';
import { getBaseFilterConfig } from '../utils/BaseFilterConfig';
import { useFilterDefinitionsQuery } from './useFilterDefinitionsQuery';
export function useFilterConfig() {
  const {
    data
  } = useFilterDefinitionsQuery();
  const appContext = useAppContext();
  return useMemo(() => {
    const baseConfig = getBaseFilterConfig();
    const completeConfig = {};
    Object.entries(baseConfig).forEach(([key, filter]) => {
      var _ref, _filter$options2, _ref2, _filter$optionGroups2;
      // Check if the filter is allowed for the current app context
      if (filter.allowedAppContext && filter.allowedAppContext !== appContext) return;

      // Falling back to empty arrays allows us to render the filter controls while loading.
      if (!data) {
        var _filter$options, _filter$optionGroups;
        completeConfig[key] = Object.assign({}, filter, {
          options: (_filter$options = filter.options) !== null && _filter$options !== void 0 ? _filter$options : [],
          optionGroups: (_filter$optionGroups = filter.optionGroups) !== null && _filter$optionGroups !== void 0 ? _filter$optionGroups : []
        });
        return;
      }
      const definition = getFilterDefinition(filter, data.result);
      completeConfig[key] = Object.assign({}, filter, {
        // If the base filter has hardcoded options, use them. Otherwise, use the options from the RPC.
        // The final `?? []` shouldn't happen, since if the filter definition is missing from the RPC,
        // then it should be hardcoded in the base filter.
        options: (_ref = (_filter$options2 = filter.options) !== null && _filter$options2 !== void 0 ? _filter$options2 : definition === null || definition === void 0 ? void 0 : definition.options) !== null && _ref !== void 0 ? _ref : [],
        optionGroups: (_ref2 = (_filter$optionGroups2 = filter.optionGroups) !== null && _filter$optionGroups2 !== void 0 ? _filter$optionGroups2 : definition === null || definition === void 0 ? void 0 : definition.optionGroups) !== null && _ref2 !== void 0 ? _ref2 : []
      });
    });
    return completeConfig;
  }, [data, appContext]);
}
function getFilterDefinition(filter, result) {
  const definitions = filter.productType ? result.filtersByProductType[filter.productType] : result.universalFilters;
  return definitions === null || definitions === void 0 ? void 0 : definitions.find(f => f.baseQueryField === filter.field);
}